/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard/index.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-dashboard'
          }
        },
        {
          path: '/agenda',
          name: 'agenda',
          component: () => import('./views/pages/Agenda/Overview.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-staff-agenda'
          }
        },
        {
          path: '/invoices',
          name: 'invoices',
          component: () => import('./views/pages/Invoices/index.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-invoices'
          },
        },
        {
          path: '/delivery-locations',
          name: 'delivery-locations',
          component: () => import('./views/pages/Delivery/Locations.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-invoices'
          },
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import('./views/pages/Orders/list.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-orders'
          },
        },
        {
          path: '/roles',
          name: 'roles',
          component: () => import('./views/pages/Staff/Roles.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-permissions'
          },
        },
        {
          path: '/permissions',
          name: 'permissions',
          component: () => import('./views/pages/Staff/Permissions.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-permissions'
          },
        },
        {
          path: '/user/settings',
          name: 'user-settings',
          component: () => import('./views/pages/Staff/Settings.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-dashboard'
          },
        },

        {
          path: '/orders/create',
          name: 'orders-create',
          component: () => import('./views/pages/Orders/create.vue'),
          meta: {
            staff: true,
            staffPermission: 'create-orders'
          },
        },
        {
          path: '/delivery/agenda',
          name: 'delivery-agenda',
          component: () => import('./views/pages/Delivery/Agenda.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-deliverer-agenda'
          },
        },
        {
          path: '/delivery/overview',
          name: 'delivery-overview',
          component: () => import('./views/pages/Delivery/Overview.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-delivery-overview'
          },
        },
        {
          path: '/delivery/deliverers',
          name: 'deliverer-overview',
          component: () => import('./views/pages/Delivery/deliverers.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-companies'
          },
        },
        {
          path: '/staff',
          name: 'staff-list',
          component: () => import('./views/pages/Staff/List.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-members'
          },
        },
        {
          path: '/staff/create',
          name: 'staff-create',
          component: () => import('./views/pages/Staff/Create.vue'),
          meta: {
            staff: true,
            staffPermission: 'create-members'
          },
        },
        {
          path: '/staff/:id/edit',
          name: 'staff-edit',
          component: () => import('./views/pages/Staff/Edit.vue'),
          meta: {
            staff: true,
            staffPermission: 'edit-members'
          },
        },
        {
          path: '/companies/list',
          name: 'companies-list',
          component: () => import('./views/pages/Companies/list.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-companies'
          },
        },
        {
          path: '/companies/create',
          name: 'create-company',
          component: () => import('./views/pages/Companies/Create.vue'),
          meta: {
            staff: true,
            staffPermission: 'view-companies'
          },
        },
        {
          path: '/companies/:slug/delivery-locations',
          name: 'companies-delivery-locations-and-fees',
          component: () => import('./views/pages/Locations/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/delivery-locations',
          name: 'global-delivery-locations',
          component: () => import('./views/pages/DeliveryLocations/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/dashboard',
          name: 'companies-dashboard',
          component: () => import('./views/pages/Companies/single/dashboard.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/contacts',
          name: 'company-contacts',
          component: () => import('./views/pages/Companies/single/Contacts.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/coupons',
          name: 'company-coupons',
          component: () => import('./views/pages/Coupon/Coupons'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/menu',
          name: 'companies-menu',
          component: () => import('./views/pages/Companies/single/menu'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/categories',
          name: 'companies-product-categories',
          component: () => import('./views/pages/Companies/single/menu/Products/Categories/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/categories/create',
          name: 'companies-product-categories-create',
          component: () => import('./views/pages/Companies/single/menu/Products/Categories/Create.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/categories/:category/edit',
          name: 'companies-product-categories-edit',
          component: () => import('./views/pages/Companies/single/menu/Products/Categories/Edit.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products',
          name: 'companies-products',
          component: () => import('./views/pages/Companies/single/menu/Products/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/create',
          name: 'companies-products-create',
          component: () => import('./views/pages/Companies/single/menu/Products/Create.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/:product/edit',
          name: 'companies-products-edit',
          component: () => import('./views/pages/Companies/single/menu/Products/Edit.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/options',
          name: 'companies-products-options',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/options/create',
          name: 'companies-products-options-create',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/Create.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/options/:option/edit',
          name: 'companies-products-options-edit',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/Edit.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/option/categories',
          name: 'companies-products-option-categories',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/Categories/index.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/option/categories/create',
          name: 'companies-products-option-categories-create',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/Categories/Create.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/products/option/categories/:category/edit',
          name: 'companies-products-option-categories-edit',
          component: () => import('./views/pages/Companies/single/menu/Products/Options/Categories/Edit.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/orders',
          name: 'companies-orders',
          component: () => import('./views/pages/Companies/single/orders.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/invoices',
          name: 'companies-invoices',
          component: () => import('./views/pages/Companies/single/invoices.vue'),
          meta: {
            staff: false,
            staffPermission: 'view-invoices'
          },
        },
        {
          path: '/invoiceables',
          name: 'global-invoiceables',
          component: () => import('./views/pages/Company/Invoiceables/index'),
          meta: {
            staff: false,
            staffPermission: 'view-invoices'
          },
        },
        {
          path: '/vehicles',
          name: 'vehicles',
          component: () => import('./views/pages/Vehicles/index'),
          meta: {
            staff: false,
            staffPermission: 'companies-settings'
          },
        },
        {
          path: '/company-categories',
          name: 'company-categories',
          component: () => import('./views/pages/Company/Category/index'),
          meta: {
            staff: false,
            staffPermission: 'companies-settings'
          },
        },
        {
          path: '/companies/:slug/reviews',
          name: 'companies-reviews',
          component: () => import('./views/pages/Companies/single/Reviews.vue'),
          meta: {
            staff: false,
          },
        },
        {
          path: '/companies/:slug/settings',
          name: 'companies-settings',
          component: () => import('./views/pages/Companies/single/settings.vue'),
          meta: {
            staff: false,
          },
        }
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/contact/resetpassword',
          name: 'reset-contact-password',
          component: () => import('@/views/pages/Company/ResetPassword.vue')
        },
        {
          path: '/contact/resetpassword/:key',
          name: 'reset-password',
          component: () => import('@/views/pages/Company/CreateNewPassword.vue')
        },
        {
          path: '/company/start',
          name: 'company-start',
          component: () => import('@/views/pages/Company/Start.vue')
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/auth/Login.vue'),
          beforeEnter: (to, from, next) => {
            if (localStorage.getItem('companytoken') !== null) {
              var company = JSON.parse(localStorage.getItem('user'))['companies'][0]
              next({ name: 'companies-dashboard', params: { slug: company.slug } })
            } else {
              next()
            }
            if (localStorage.getItem('stafftoken') !== null) {
              next('/')
            } else {
              next()
            }
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  if(to.meta.staff) {
    if(localStorage.getItem('stafftoken') !== null ) {
      Axios.get('https://staffapi.hebtrek.nl/v1/staff/permissions', {
          headers: {
              Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
          }
      }).then((response) => {
          let permissions = response.data
          if(permissions.includes(to.meta.staffPermission)) {
            next()
          }
      }).catch((error) => {
          console.log(error)
      });
    } else {
      next('/login')
    }
  } else {
    if (localStorage.getItem('companytoken') !== null) {
      if (to.path === '/') {
        let company = JSON.parse(localStorage.getItem('user')['companies'][0])
        next({ name: 'companies-dashboard', params: { slug: company.slug } });
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default router
